import React from 'react';
import { ServiceSection, PageTitle, Section, Seo } from '../components/ui';
import lang from '../assets/lang';

export const Services = () => {

	const getServices = () =>
		lang.services.map(service => (
			<ServiceSection
				key={service.title}
				title={service.title}
				text={service.text}
				image={service.image}
				techImages={service.techImages}
			/>
		));

	return (
		<div>
			<Seo
				pageTitle={lang.servicesSeo.pageTitle}
				metaDescription={lang.servicesSeo.metaDescription}
				metaKeywords={lang.servicesSeo.metaKeywords}
			/>
			<PageTitle
				title={lang.titleServices}
				text={lang.textServices} />

			<Section sectionType="what-we-do" title={lang.titleWhatWeDo} text={lang.textWhatWeDo}>
				{getServices()}
			</Section>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/pages/Services.js